import { Container, Row, Col } from "react-bootstrap";
// import logo from "../assets/img/logo.html";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/x-icon.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
                <a href = "https://github.com/joeygitari" target='blank' rel='noreferrer'><img src={navIcon1} alt =""/></a>
                <a href = "https://www.linkedin.com/in/joanne-gitari-48105b235/" target='blank' rel='noreferrer'><img src={navIcon2} alt =""/></a>
                <a href = "https://x.com/jo_gitari" target='blank' rel='noreferrer'><img src={navIcon3} alt =""/></a>
            </div>
            <p><a href = "mailto:jgitaridev@gmail.com" rel='noreferrer' className="text-white text-decoration-none">💌 jgitaridev@gmail.com </a></p>
            <p>Copyright 2025. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}